import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOfficeFilePdf1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "office-file-pdf-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.246,23.248h-3a1.5,1.5,0,0,1-1.5-1.5V2.248a1.5,1.5,0,0,1,1.5-1.5H12.875a1.5,1.5,0,0,1,1.061.44l5.871,5.871a1.5,1.5,0,0,1,.439,1.061v4.628"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.246,8.248h-6a1.5,1.5,0,0,1-1.5-1.5v-6"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.246,
			y1: 23.248,
			x2: 8.246,
			y2: 15.748
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.246,15.748H9a2.25,2.25,0,0,1,0,4.5h-.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M14.246,23.248a3,3,0,0,0,3-3v-1.5a3,3,0,0,0-3-3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.246,23.248v-6a1.5,1.5,0,0,1,1.5-1.5h1.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 20.246,
			y1: 20.248,
			x2: 22.496,
			y2: 20.248
		})
	]
});
export default SvgOfficeFilePdf1;
